export default "__VITE_ASSET__BrshHlM8__"